<field-integer-readonly *ngIf="field.readonly; else editable" [field]="field"></field-integer-readonly>
<ng-template #editable>
  <field-integer-multiple *ngIf="field.multiple" [formGroup]="formGroup" [field]="field"></field-integer-multiple>
  <field-integer-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-integer-single>
</ng-template>
